window.vidio = window.vidio || {};

import NativeComponentInitializers from '../../shared/native_component_initializers';
window.NativeComponentInitializers = NativeComponentInitializers;

window.tmpl = require('blueimp-tmpl');
window.Cookies = require('js-cookie');

import '../../../vendor/bootstrap/tooltip.js';
import '../../shared/string_number_helper';
import 'javascripts/jquery.timeago';
import { VidioHelpers, helpers } from '../../shared/vidio_helpers';
window.VidioHelpers = VidioHelpers;
window.vidio.helpers = helpers;

window.GAEvent = require('../../shared/ga_event').default;
window.AhoyPageviewEvent = require('../../shared/ahoy_pageview_event').default;
window.AhoyEvent = require('../../shared/ahoy_event').default;
window.Kmklabs = require('../../desktop/components/kmklabs').default;
window.LivestreamingOverlay = require('../../embed/components/livestreaming_overlay').default;
window.EmbedPolicy = require('../../embed/components/embed_policy').default;
window.PlayCount = require('../../shared/components/play_count').default;
window.DiscussionItem = require('../../shared/components/discussion_item').default;
window.Discussion = require('../../shared/components/discussion').default;
window.EmbedShare = require('../../embed/components/embed_share').default;
window.GtmEmbed = require('../../embed/components/gtm_embed').default;
window.FontLoader = require('../../shared/font_loader').default;
window.EmbedInteractionStatus = require('../../embed/initializers/embed_interaction_status').default;

// Adblock detector
window.AdBlockDetector = require("../../shared/ad_block_detector").default;

// WebSocket
import WebSocketConnection from '../../shared/components/live/web_socket_connection';
window.WebSocketConnection = WebSocketConnection;

window.vidio = {
  init: function(){
    window.PlayCount.load();

    $("*[data-toggle='tooltip']").tooltip();
    window.GtmEmbed.init();
  },
  livestreamings: {
    init_embed: function() {
      if (window.location.href.indexOf("live_chat=true") !== -1) {
        var discussion = new window.Discussion();
        discussion.init();
      }
    }
  },
  config: {},
  videos: {}
};

// Run component initializers
$(document).ready(function() {
  (require('../../embed/ga_event_list').default)();
  window.FontLoader.run();
  window.vidio.init();
  new NativeComponentInitializers();
  window.EmbedInteractionStatus.init();
});
